import formatDate from './formatDate'

function buildPerformanceSeries({ sortBy, sortByLabel, performance }) {
  if (performance[0] && !performance[0].name) {
    return [
      {
        name: sortByLabel,
        data: performance.map(p => p[sortBy]),
      },
    ]
  }
  if (performance[0]?.name) {
    return performance.map(perf => {
      return {
        name: perf.name,
        data: perf.data.map(p => p[sortBy] ?? 0),
      }
    })
  }
}

function date(dateString) {
  return new Date(dateString).toLocaleString('en-US', { timeZone: 'UTC' })
}

function buildPerformanceCategories(performance, format = null) {
  if (!performance[0]) return []
  if (performance[0] && !performance[0].name) {
    return performance.map(p => ({
      date: formatDate(date(p.date), format ? format : 'MMM/YYYY'),
      isSubscribersInterpolated: p.isSubscribersInterpolated,
    }))
  }
  if (performance[0].data) {
    return performance[0].data.map(p => formatDate(date(p.date), format ? format : 'MMM/YYYY'))
  }
  return []
}

function buildPiechardSeries(sortBy, performance) {
  const series = performance.reduce((acc, p) => {
    if (!acc[sortBy]) acc[sortBy] = 0
    acc[sortBy] += p[sortBy]

    return acc
  }, {})

  //Avg // ParseInt To prevent Piechart Bug
  series[sortBy] = [parseInt(series[sortBy] / performance.length)]
  return series
}

function checkDecreasingGraph(series) {
  let haveDecreasingValue = false

  series.map(serie => {
    return serie.data.map((value, index, array) => {
      if (index > 0 && !!value && array[index - 1] > value) {
        haveDecreasingValue = true
      }
      return false
    })
  })

  return haveDecreasingValue
}

function checkNegativeGraph(series) {
  let haveNegativeValue = false

  series.map(serie => {
    const negativeValueFound = serie.data.some(value => value < 0)
    if (negativeValueFound) haveNegativeValue = negativeValueFound
    return ''
  })

  return haveNegativeValue
}

function checkEmptyGraph(series) {
  try {
    const isEmpty = series[0].data.every(element => element === null)
    return isEmpty
  } catch {
    return true
  }
}

function removeEmptyValues(series, categories) {
  const data = series[0].data

  // remove the last day if it's today and there is no data
  if (data[data.length - 1] === null) {
    const today = formatDate(date(new Date()), 'DD/MM/YYYY')
    if (categories[categories.length - 1] === today) {
      data.pop()
      categories.pop()
    }
  }

  // remove the first days if there is no data
  if (data[0] === null) {
    data.some(element => {
      if (element === null) {
        data.shift()
        categories.shift()
        return false
      }
      return true
    })

    // if items were removed
    return true
  }

  // if items were not removed
  return false
}

function renderLegendWithProviderIcon(seriesName) {
  // handles the case in which the creator's name has colons
  const seriesSplit = seriesName.split(':')
  const provider = seriesSplit.pop()
  const name = seriesSplit.join(':')

  if (provider) {
    return `
       <div class="icon-legend">
         <span>${name}</span>
       </div>
    `
  }

  return name
}

export default {
  buildPerformanceCategories,
  buildPerformanceSeries,
  buildPiechardSeries,
  checkDecreasingGraph,
  checkEmptyGraph,
  checkNegativeGraph,
  date,
  removeEmptyValues,
  renderLegendWithProviderIcon,
}
